module.exports = __webpack_public_path__ + "static/media/task-management_SK.9da682ce.md";